import { IconButton, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"
import { prevent } from "lib/prevent"
import { RejectionUpdatedBy } from "./rejection-updated-by"
import { RegimeDraftLockHide } from "routes/regime/regime-draft-locking/regime-draft-lock-hide"

export function RejectionDisplay({ payload, onEdit }) {
    const { allowEdit = true, isEditable = true } = useBoundContext()

    return (
        <>
            <Stack
                direction="row"
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                        alignItems: "center",
                    }}
                >
                    <Iconify
                        icon="iconamoon:comment-close-fill"
                        sx={{ color: "error.main", width: "20px", height: "20px" }}
                    />
                    <Typography variant="subtitle2">Rejection</Typography>
                </Stack>
                <If truthy={allowEdit && !isEditable}>
                    <RegimeDraftLockHide>
                        <IconButton
                            aria-label="Edit rejection"
                            onClick={prevent(onEdit)}
                            data-cy="edit-rejection-button"
                        >
                            <Iconify icon="mdi:pencil" sx={{ color: "error.dark", width: "16px", height: "16px" }} />
                        </IconButton>
                    </RegimeDraftLockHide>
                </If>
            </Stack>
            <Typography variant="body2" sx={{ wordBreak: "break-word", whiteSpace: "pre-line" }}>
                {payload?.reason}
            </Typography>
            <RejectionUpdatedBy payload={payload} />
        </>
    )
}
